import { FC } from 'react';
import { FormattedMessage } from 'dibs-react-intl';
import { graphql, createFragmentContainer } from 'react-relay/legacy';
import { PdpSharedDetailShipsFrom_item$data } from './__generated__/PdpSharedDetailShipsFrom_item.graphql';
import { useAddItemLocationPdpVariant } from '../PdpSharedShippingInfo/itemLocationPdpAbTestHelpers';
// styles
import classnames from 'classnames';
import styles from '../shared/PdpSharedDetail/PdpSharedDetail.scss';
import dibsCss from 'dibs-css';

type Props = {
    item: PdpSharedDetailShipsFrom_item$data;
};

const PdpSharedDetailShipsFromComponent: FC<Props> = props => {
    const isAddItemLocationPdpVariant = useAddItemLocationPdpVariant();
    const itemAddress = props?.item?.address?.itemAddress;

    const itemAddressElement = <span className={dibsCss.sassyFontBody}>{itemAddress}</span>;

    return itemAddress ? (
        <div
            className={classnames(styles.shipsFromDetail, {
                [dibsCss.mtXxsmall]: !isAddItemLocationPdpVariant,
                [dibsCss.mtXsmall]: isAddItemLocationPdpVariant,
            })}
        >
            <span
                className={
                    isAddItemLocationPdpVariant ? dibsCss.sassyFontBodyTypeHeavy : styles.title
                }
            >
                {isAddItemLocationPdpVariant ? (
                    <FormattedMessage
                        id="pdp.pdpShippingDetails.shipsFrom.variant"
                        defaultMessage="Shipping from: {itemAddressElement}"
                        values={{ itemAddressElement }}
                    />
                ) : (
                    <FormattedMessage
                        id="pdp.pdpShippingDetails.shipsFrom.control"
                        defaultMessage="Ships From: {itemAddressElement}"
                        values={{ itemAddressElement }}
                    />
                )}
            </span>
        </div>
    ) : null;
};

export const PdpSharedDetailShipsFrom = createFragmentContainer(PdpSharedDetailShipsFromComponent, {
    item: graphql`
        fragment PdpSharedDetailShipsFrom_item on Item {
            address {
                itemAddress: displayCityStateCountry(fullCountryName: true)
            }
        }
    `,
});
